import React from 'react';
import segiImg from '../../assets/segi-partnership/segipartnership.jpeg'; // update path
import LazyImage from '../common/LazyImage';
import { Link } from 'react-router-dom';

const SegiPartnership = () => {
  return (
    <section className="py-16 px-6 ">
      <div className="max-w-6xl mx-auto">

        {/* Section label */}
        {/* <div className="flex items-center gap-2 mb-10">
          <span className="w-8 h-0.5 bg-red-600" />
          <p className="text-xs font-medium uppercase tracking-widest text-red-600">
            Global Academic Partnership
          </p>
        </div> */}

        <div className="flex flex-col md:flex-row items-center gap-10">

          {/* Left — Text */}
          <div className="flex-1 order-2 md:order-1">

            <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight mb-4">
              First Aviation Institute in India to Partner with{' '}
              <span className="text-red-600">SEGi University,</span>{' '}
              Malaysia
            </h2>

            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              Skyford Aviation has made history as the first aviation institution
              in India to establish a global academic partnership with SEGi
              University, Malaysia — a QS World University ranked institution.
              This collaboration opens international pathways for our students
              in aviation, management, and technology.
            </p>

            {/* Highlight pills */}
            <div className="flex flex-wrap gap-3 mb-8">
              {[
                'QS World University Ranked',
                'International Exposure',
                'Globally Recognised Degree',
                'Study in Malaysia',
              ].map((tag, i) => (
                <span
                  key={i}
                  className="text-xs px-3 py-1.5 rounded-full border border-red-200 text-red-700 bg-red-50"
                >
                  {tag}
                </span>
              ))}
            </div>

            {/* CTA */}
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium px-5 py-2.5 rounded-lg transition-colors"
            >
              Learn more about us
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>

          </div>

          {/* Right — Image */}
          <div className="flex-1 order-1 md:order-2 w-full">
            <div className="relative rounded-2xl overflow-hidden border-4 border-red-100">
              <LazyImage
              src={segiImg}
               alt="SEGi University Malaysia — Global Partner of Skyford Aviation"
               className="w-full object-cover"
              />




              {/* Badge overlay */}
              <div className="absolute bottom-4 left-4 bg-white rounded-xl px-4 py-2.5 shadow-sm border border-gray-100">
                <p className="text-xs text-gray-400 mb-0.5">In partnership with</p>
                <p className="text-sm font-semibold text-gray-800">SEGi University, Malaysia</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SegiPartnership;